import { CopelTechnicalStandards } from './pages/CopelTechnicalStandards'

import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

export const App = () => {
  return (
    <CopelTechnicalStandards />
  )
}
